import api from '@/services/api';

function findAllGrids() {
  return api().get('grids?perPage=100');
}

function findAllProducts() {
  return api().get('products?perPage=100');
}

function findAllInsurers() {
  return api().get('insurers?sort=name');
}

function findAllLegalForms() {
  return api().get('legal_forms');
}

function findAllQualityOccupants() {
  return api().get('quality_occupants');
}
function findAllEquipments() {
  return api().get('equipments');
}
function findAllPositions() {
  return api().get('post_positions');
}

function getRecommendation(risk) {
  return api().post('raters/recommendation', { ...risk });
}

function findAllRecommendationsFromCompanyId(companyId) {
  return api().get(`companies/${companyId}/recommendation`);
}

function findAllEmployeesBrackets() {
  return api().get('employees_bracket');
}

export {
  getRecommendation,
  findAllEmployeesBrackets,
  findAllGrids,
  findAllInsurers,
  findAllLegalForms,
  findAllPositions,
  findAllProducts,
  findAllQualityOccupants,
  findAllEquipments,
  findAllRecommendationsFromCompanyId,
};
